module.exports = __webpack_public_path__ + "img/icon_enjoy05@2x.0b0517a0.png";